var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStoreActive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#EFF6E1"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_127_6564",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_127_6564)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.025 15.05V23C25.025 23.55 24.8292 24.0208 24.4375 24.4125C24.0459 24.8042 23.575 25 23.025 25H9.02503C8.47503 25 8.00419 24.8042 7.61253 24.4125C7.22086 24.0208 7.02503 23.55 7.02503 23V15.05C6.64169 14.7 6.34586 14.25 6.13753 13.7C5.92919 13.15 5.92503 12.55 6.12503 11.9L7.17503 8.5C7.30836 8.06667 7.54586 7.70833 7.88753 7.425C8.22919 7.14167 8.62503 7 9.07503 7H22.975C23.425 7 23.8167 7.1375 24.15 7.4125C24.4834 7.6875 24.725 8.05 24.875 8.5L25.925 11.9C26.125 12.55 26.1209 13.1417 25.9125 13.675C25.7042 14.2083 25.4084 14.6667 25.025 15.05ZM18.225 14C18.675 14 19.0167 13.8458 19.25 13.5375C19.4834 13.2292 19.575 12.8833 19.525 12.5L18.975 9H17.025V12.7C17.025 13.05 17.1417 13.3542 17.375 13.6125C17.6084 13.8708 17.8917 14 18.225 14ZM13.725 14C14.1084 14 14.4209 13.8708 14.6625 13.6125C14.9042 13.3542 15.025 13.05 15.025 12.7V9H13.075L12.525 12.5C12.4584 12.9 12.5459 13.25 12.7875 13.55C13.0292 13.85 13.3417 14 13.725 14ZM9.27503 14C9.57503 14 9.83753 13.8917 10.0625 13.675C10.2875 13.4583 10.425 13.1833 10.475 12.85L11.025 9H9.07503L8.07503 12.35C7.97503 12.6833 8.02919 13.0417 8.23753 13.425C8.44586 13.8083 8.79169 14 9.27503 14ZM22.775 14C23.2584 14 23.6084 13.8083 23.825 13.425C24.0417 13.0417 24.0917 12.6833 23.975 12.35L22.925 9H21.025L21.575 12.85C21.625 13.1833 21.7625 13.4583 21.9875 13.675C22.2125 13.8917 22.475 14 22.775 14Z",
    fill: "#6BB700"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreActive);
export default __webpack_public_path__ + "static/media/store-active.94beb76e83b847010de4d40e35cc2368.svg";
export { ForwardRef as ReactComponent };